module.exports = __webpack_public_path__ + "assets/img/HomePhone.71a20d84.png";